import styles from "./styles/Customization.module.css";
import Spinner from "../../components/ui/spinner/Spinner";
import OutputWindow from "../../components/ui/output_window/OutputWindow";
import NavButton from "../../components/ui/navbutton/NavButton";
import DataContext from "../../context/DataContext";

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

const Modal = ({
    inProcess, // In process state
    success, // Success state
}) => {
    const { currentCustom, homePath } = useContext(DataContext);
    const { t } = useTranslation();

    return (
        <>
            {inProcess ? (
                // Show spinner while in process
                <Spinner />
            ) : (
                <section
                    className={` ${styles.main_page_container} main-container flex-container`}
                >
                    <div
                        className={`${styles.main_form_container} ${styles.window} v-flex-container`}
                    >
                        <OutputWindow
                            // The color of the output window is based on the success state
                            color={
                                success
                                    ? currentCustom?.color?.current
                                    : currentCustom?.color?.error
                            }
                            // the content of the output window is based on the success state
                            content={
                                <div
                                    className={`${styles.result_text_container} v-flex-container`}
                                >
                                    <h1>
                                        {success
                                            ? t(`data saved successfully`)
                                            : t(`error saving data`)}
                                    </h1>
                                </div>
                            }
                        />

                        <div
                            className={`${styles.result_buttons_container} flex-container`}
                        >
                            <div>
                                <NavButton
                                    body={t(`back to search`)}
                                    link={homePath}
                                    disableHTML={inProcess}
                                    disabled={inProcess}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};

export default Modal;
